import e, { useState as t, useCallback as o } from "react";
import { createPortal as n } from "react-dom";
import i from "disable-scroll";

var r = {
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1e3
},
    l = {
  position: "fixed",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1e5
},
    c = {
  position: "relative",
  zIndex: 100001
},
    d = function d(t) {
  var o = t.children,
      i = t.isOpen,
      d = t.elementId,
      a = void 0 === d ? "root" : d;
  return !1 === (void 0 !== i && i) ? null : /*#__PURE__*/n( /*#__PURE__*/e.createElement("div", {
    style: r
  }, /*#__PURE__*/e.createElement("div", {
    style: l,
    onClick: t.onOverlayClick
  }), /*#__PURE__*/e.createElement("div", {
    style: c
  }, o)), document.getElementById(a));
},
    a = function a(n, r) {
  void 0 === n && (n = "root"), void 0 === r && (r = {});
  var l = r.preventScroll,
      c = void 0 !== l && l,
      a = r.closeOnOverlayClick,
      m = void 0 === a || a,
      f = t(!1),
      v = f[0],
      p = f[1],
      s = o(function () {
    p(!0), c && i.on();
  }, [p, c]),
      u = o(function () {
    p(!1), c && i.off();
  }, [p, c]),
      y = o(function (e) {
    e.stopPropagation(), m && u();
  }, [m, u]);
  return [o(function (t) {
    return /*#__PURE__*/e.createElement(d, {
      isOpen: v,
      onOverlayClick: y,
      elementId: n
    }, t.children);
  }, [v, u, n]), s, u, v];
};

export { a as useModal };